import service from './services.js'

export const initFcm = (config) => {

    if (!config) return;

    const firebaseConfig = {
        apiKey: config.api_key,
        authDomain: config.auth_domain,
        projectId: config.project_id,
        storageBucket: config.storage_bucket,
        messagingSenderId: config.messaging_sender_id,
        appId: config.app_id
    };

    const firebase = window.firebase;

    if (firebase && !firebase.apps.length) {

        firebase.initializeApp(firebaseConfig);

    }

    const isSupported = typeof window !== 'undefined' && 'serviceWorker' in navigator && 'Notification' in window && 'PushManager' in window;

    if (!isSupported) return;

    const swParams = new URLSearchParams(firebaseConfig).toString();

    navigator.serviceWorker.register(`/firebase-messaging-sw.js?${swParams}`).then(() => {

        if (Notification.permission === 'granted') {

            registerPushToken(config.vapid_key);
            listenForegroundNotifications();

            return;

        }

        if (Notification.permission === 'default') {

            document.addEventListener('click', () => {

                Notification.requestPermission().then((permission) => {

                    if (permission !== 'granted') return;

                    registerPushToken(config.vapid_key);
                    listenForegroundNotifications();

                });

            }, {once: true});

        }

    }).catch((err) => {

        console.error('Service Worker register error', err);

    });

    listenLogout();
    
};

export const registerPushToken = (vapidKey) => {

    const firebase = window.firebase;

    if (!firebase || !firebase.messaging) return;

    const messaging = firebase.messaging();

    navigator.serviceWorker.ready.then((registration) => {

        return messaging.getToken({vapidKey: vapidKey, serviceWorkerRegistration: registration});

    }).then((token) => {

        if (token) {

            const data = {token: token, device_id: getDeviceId()};

            return service.notifications.registerPushToken(data);

        }

    })
    .catch((err) => {

        console.error('Get fcm token error:', err);

    });

};

const getDeviceId = () => {

    let deviceId = localStorage.getItem('device_id');
    
    if (!deviceId) {

        deviceId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {

            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);

            return v.toString(16);

        });
        
        localStorage.setItem('device_id', deviceId);

    }
    
    return deviceId;

};

export const listenForegroundNotifications = () => {

    const firebase = window.firebase;

    if (!firebase || !firebase.messaging) return;

    const messaging = firebase.messaging();

    messaging.onMessage((payload) => {

        if (document.hidden) return;

        try {

            const notification = payload && payload.notification ? payload.notification : {};
            const data = payload && payload.data ? payload.data : {};

            const title = notification.title || '';
            const body = notification.body || '';
            const path = data && data.path ? data.path : null;

            if (Notification.permission === 'granted') {

                const notification = new Notification(title, {body: body, data: data});

                notification.onclick = (e) => {

                    e.preventDefault();

                    window.focus();

                    if (path) window.location.href = path;

                    notification.close();

                };

            }

        } catch (err) {

            console.error('Notification error:', err);

        }

    });

};

export const listenLogout = () => {

    const logoutBtn = document.getElementById('logout-btn');

    if (!logoutBtn) return;

    logoutBtn.addEventListener('click', (e) => {

        e.preventDefault();

        const logoutUrl = logoutBtn.getAttribute('href');
        const deviceId = localStorage.getItem('device_id');

        if (!deviceId) {

            window.location.href = logoutUrl;

            return;

        }

        service.notifications.deactivatePushToken({device_id: deviceId}).catch((err) => {

            console.log('Deactivate push token error', err);

        }).finally(() => {

            window.location.href = logoutUrl;

        });

    });

}



// WEBPACK FOOTER //
// ./frontEnd/notifications/services/fcmService.js